import { create } from 'zustand';

import { EMPTY_NODES } from '../consts';
import { type CanvasTokenNodeSlice, createCanvasTokenNodeSlice } from './slices/createCanvasTokenNodeSlice';

export type CanvasTokenNodeState = CanvasTokenNodeSlice;

export const useCanvasTokenNodeStore = create<CanvasTokenNodeState>()((...args) => ({
  ...createCanvasTokenNodeSlice()(...args),
}));

/** Returns all canvas token nodes. */
export const useCanvasTokenNodes = () => {
  return useCanvasTokenNodeStore((state) => (Object.keys(state.nodes).length > 0 ? state.nodes : EMPTY_NODES));
};

/** Returns true if a canvas node with the given runId exists. */
export const useIsNodeOnCanvas = (runId: string) => {
  return useCanvasTokenNodeStore((state) =>
    Object.values(state.nodes).some((node) => 'runId' in node && node.runId === runId),
  );
};
